import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/banner.jpg'
import _imports_1 from '@/assets/tehnipedia.png'
import _imports_2 from '@/assets/calculator.png'
import _imports_3 from '@/assets/rute.png'


const _withScopeId = n => (_pushScopeId("data-v-43dd830a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Alerta aveti facturi depasite ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "click aici pentru vizualizare", -1))
const _hoisted_4 = {
  key: 1,
  class: "app__page__title__container",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_5 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pagina Principala")
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "dashboard__section" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "ACTIVITATE", -1))
const _hoisted_10 = { class: "dashboard__div__content" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" CAUTA ARTICOLE ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" ARTICOLE FAVORITE ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" OFERTE ")
const _hoisted_14 = { class: "dashboard__section" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "DATE FINANCIARE", -1))
const _hoisted_16 = { class: "dashboard__div__content" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" BALANTA ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" FACTURI ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" ALERTE ")
const _hoisted_20 = { class: "dashboard__section" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "CONTUL MEU", -1))
const _hoisted_22 = { class: "dashboard__div__content" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" DATE COMPANIE ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" UTILIZATORI ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" ADRESE DE LIVRARE ")
const _hoisted_26 = { class: "dashboard__section" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "INFO UTILE", -1))
const _hoisted_28 = { class: "dashboard__div__content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" TEHNIPEDIA ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" SERVICE CENTER ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" CALCULATOR GREUTATE ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" RUTE DISTRIBUTIE ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAlertDepasireTermenFacturi)
      ? (_openBlock(), _createBlock(_component_q_banner, {
          key: 0,
          dense: "",
          "inline-actions": "",
          class: "text-white bg-red q-ma-md",
          style: {"width":"100%","margin":"0 auto","cursor":"pointer"},
          onClick: _ctx.onGoFacturi
        }, {
          action: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "white",
              name: "close",
              onClick: _ctx.closeAlertDepasireTermenFacturi,
              style: {"cursor":"pointer"}
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_icon, {
              name: "dashboard",
              style: {"font-size":"2rem","position":"relative","top":"-3px"},
              color: "primary"
            }),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_img, {
      src: _imports_0,
      style: {"margin-right":"7vw"}
    }),
    (_ctx.$q.platform.is.mobile)
      ? (_openBlock(), _createElementBlock("br", _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoCautaArticole && _ctx.onGoCautaArticole(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "category",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_11
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onGoArticoleFavorite && _ctx.onGoArticoleFavorite(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "favorite_border",
            color: "red",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_12
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGoToOffers && _ctx.onGoToOffers(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "shop",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_13,
          (_ctx.userStore.countOferte>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countOferte), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onGoBalanta && _ctx.onGoBalanta(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "star_rate",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_17
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onGoFacturi && _ctx.onGoFacturi(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "paid",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_18
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onGoAlerte && _ctx.onGoAlerte(...args)))
        }, [
          (_ctx.showAlertCount)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red-3",
                transparent: "",
                class: "badge__superscript--top"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.overdueInvoiceCount), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_icon, {
            name: "warning_amber",
            color: "red",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_19
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGoDateCompanie && _ctx.onGoDateCompanie(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "account_balance",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_23
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGoUsersCompany && _ctx.onGoUsersCompany(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "people",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_24
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onGoNomAdreseLivrare && _ctx.onGoNomAdreseLivrare(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "local_shipping",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_25,
          (_ctx.userStore.countAdrese>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countAdrese), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openLink('https://color-metal.ro/ro/tehnipedia')))
        }, [
          _createVNode(_component_q_icon, {
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }),
          _hoisted_30
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openLink('https://color-metal.ro/ro/servicii-de-calitate')))
        }, [
          _createVNode(_component_q_icon, {
            name: "call",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_31
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openLink('https://color-metal.ro/ro/calculator-greutate')))
        }, [
          _createVNode(_component_q_icon, { style: {"font-size":"1.4rem","padding-right":"0.3rem"} }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }),
          _hoisted_33
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openLink('https://color-metal.ro/ro/rute-de-distributie')))
        }, [
          _createVNode(_component_q_icon, {
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }, {
            default: _withCtx(() => [
              _hoisted_34
            ]),
            _: 1
          }),
          _hoisted_35
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ])
  ]))
}